module.exports = __webpack_public_path__ + "img/helpers.1e4f88b.svg";